import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ModalContextProvider } from 'src/components/Modal/provider'
import { initSentry } from 'src/service/utils/sentry/init'

initSentry()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  // <React.StrictMode>
  <ModalContextProvider>
    <App />
  </ModalContextProvider>,
  // </React.StrictMode>
)
